export default __webpack_public_path__ + "static/media/location_icon.638a0f42.svg";